import React, { FC } from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import useExperienceEditorPlaceholder from '../../hooks/useExperienceEditorPlaceholder';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import ProductDownloadBrochures from '../@shared/productDownloadBrochures';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import {
  descriptionKeyLatestDownloadBrochures,
  eyebrowKeyLatestDownloadBrochures,
  titleKeyLatestDownloadBrochures,
} from '../../constants/dictionary.constants';
import { ProductLatestDownloadBrochuresProps } from './types/productLatestDownloadBrochures.types';
import { ProductLatestDownloadBrochuresModel } from './models/productLatestDownloadBrochures.model';
import './styles.scss';

const ProductLatestDownloadBrochures: FC<ProductLatestDownloadBrochuresProps> = (props) => {
  const model = new ProductLatestDownloadBrochuresModel(props);
  const apiResponse = isEmptyResponse(props);
  const brochures = [...model.items];
  const isPlaceholderShown = useExperienceEditorPlaceholder(props);
  const canShowComponent = model.items?.length > 0;
  const componentName = props?.rendering?.componentName;

  // Component is unreleased
  if (props.fields.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  // //  star node opened directly in EE
  if (isPlaceholderShown) {
    return (
      <ExperienceEditorComponentPlaceholder
        image={props.fields?.itemData?.thumbnail}
        componentName={componentName}
      />
    );
  }

  if ((!apiResponse || !canShowComponent) && isEditorActive()) {
    return <EmptyApiDataMessage componentName={componentName} />;
  }

  if ((!apiResponse && !isPlaceholderShown && !isEditorActive()) || !canShowComponent) {
    return null;
  }

  return (
    <ProductDownloadBrochures
      fields={{
        apiData: {
          id: '',
          title: '',
          componentType: '',
          innerComponents: [],
          brochures: {
            assets: brochures,
          },
        },
        itemData: {
          iconsList: model.iconList,
          thumbnail: '',
        },
        isComponentUnreleased: false,
      }}
      titleDictionaryKeyBrochure={titleKeyLatestDownloadBrochures}
      eyebrowDictionaryKeyBrochure={eyebrowKeyLatestDownloadBrochures}
      descriptionDictionaryKeyBrochure={descriptionKeyLatestDownloadBrochures}
      extraClassName="product-latest-download-brochure"
    />
  );
};

export default ProductLatestDownloadBrochures;
